module.exports = __webpack_public_path__ + "static/cronex-logo-54611fa20454b7005ed247931e343ef7.png";